export default "__VITE_ASSET__BFhDgcaT__"